module.exports = __webpack_public_path__ + "img/Pic_Services-5.3ed1ef9f.jpg";